module.exports = __webpack_public_path__ + "static/00011.e3f2fe76.jpg";